import { render, staticRenderFns } from "./DistributorHistorical.vue?vue&type=template&id=5729afab&scoped=true"
import script from "./DistributorHistorical.vue?vue&type=script&lang=js"
export * from "./DistributorHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5729afab",
  null
  
)

export default component.exports